import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function usePiekAnalysesForOrg(orgId: string | null | undefined) {
  return useQuery({
    queryKey: ['piek-analyses-org', orgId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('piek_analyses')
        .select('id, name, analysis_year, raw_data, created_at')
        .eq('organization_id', orgId!)
        .not('raw_data', 'is', null)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!orgId,
  });
}
